import ReactDatePicker from "react-datepicker";
import moment from "moment-timezone";

type Props = {
  mode: "date-time" | "date" | "time";
  value: string | Date | null;
  onChange: (date: Date | null) => void;
  label?: string;
  style?: React.CSSProperties;
  minDate?: Date;
  maxDate?: Date;
  name?: string;
  disabled?: boolean;
};

const inputClassName =
  "block w-full rounded-md shadow-sm border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm h-10 px-3";

export function DateTimePickerDynamic(p: Props) {
  const selected = p.value ? moment(p.value).toDate() : null;

  return (
    <div style={p.style}>
      {p.label ? <label className="block text-sm font-extrabold mb-1">{p.label}</label> : null}
      {p.mode === "date" ? (
        <ReactDatePicker
          selected={selected}
          onChange={date => p.onChange(date)}
          dateFormat="EEE, MMMM d, yyyy"
          minDate={p.minDate}
          maxDate={p.maxDate}
          preventOpenOnFocus
          wrapperClassName="w-full"
          className={`${inputClassName} ${p.disabled ? "bg-gray-100 cursor-not-allowed" : "cursor-pointer"}`}
          disabled={p.disabled}
        />
      ) : p.mode === "time" ? (
        <ReactDatePicker
          selected={selected}
          onChange={date => p.onChange(date)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={5}
          timeCaption="Time"
          dateFormat="h:mm aa"
          preventOpenOnFocus
          wrapperClassName="w-full"
          className={`${inputClassName} ${p.disabled ? "bg-gray-100 cursor-not-allowed" : "cursor-pointer"}`}
          disabled={p.disabled}
        />
      ) : (
        <ReactDatePicker
          selected={selected}
          onChange={date => p.onChange(date)}
          showTimeSelect
          timeIntervals={5}
          timeCaption="Time"
          dateFormat="MMMM d, yyyy h:mm aa"
          minDate={p.minDate}
          maxDate={p.maxDate}
          preventOpenOnFocus
          wrapperClassName="w-full"
          className={`${inputClassName} ${p.disabled ? "bg-gray-100 cursor-not-allowed" : "cursor-pointer"}`}
          disabled={p.disabled}
        />
      )}
    </div>
  );
}
